module.exports = __webpack_public_path__ + "static/media/ios-share-alt.0bf667a1.svg";